import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {TranslocoService} from '@jsverse/transloco';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {filter, Subject} from 'rxjs';
import {delay, switchMap, take, takeUntil} from 'rxjs/operators';
import {GlobalService} from '../../../../../../global/global.service';
import {
    IGenerateActivityFormData
} from '../../../../contract-control/modals/bulk-upload-modal/ai-generate-activity/ai-generate-activity.component';
import {
    MatchContractCardsStepComponent
} from '../../../../contract-control/modals/bulk-upload-modal/steps/match-contract-cards-step/match-contract-cards-step.component';
import {
    IUploadFilesService, IUploadFilesServiceToken, IUploadSettingsResponse, UploadFilesService
} from '../../../../contract-control/modals/bulk-upload-modal/upload-files.service';
import {UploadPDFUpload} from '../../../../contract-control/modals/bulk-upload-modal/upload-pdf-common';
import {DocumentsBulkUploadEffects} from '../store/documents-bulk-upload.effects';
import {DocumentsBulkUploadFacade} from '../store/documents-bulk-upload.facade';
import {DocumentBulkUploadStepEnum} from '../store/documents-bulk-upload.reducers';

@Component({
    selector: 'app-documents-bulk-upload',
    templateUrl: './documents-bulk-upload.component.html',
    styleUrl: './documents-bulk-upload.component.scss',
    providers: [
        {
            provide: IUploadFilesServiceToken,
            useClass: UploadFilesService
        }
    ]
})
export class DocumentsBulkUploadComponent  extends UploadPDFUpload  implements OnInit, OnDestroy {
    private onDestroy$: Subject<void> = new Subject();

    private isActivityFormDataValid: boolean;

    constructor(public documentsBulkUploadFacade: DocumentsBulkUploadFacade, private activeModal: NgbActiveModal, private documentsBulkUploadEffects: DocumentsBulkUploadEffects, formBuilder: FormBuilder, translocoService: TranslocoService, globalService: GlobalService, @Inject(IUploadFilesServiceToken) uploadService: IUploadFilesService,) {
        super(formBuilder, uploadService, globalService, translocoService);
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    ngOnInit(): void {
        this.documentsBulkUploadEffects.closeModal
            .pipe(takeUntil((this.onDestroy$)))
            .subscribe(() => {
                this.activeModal.close();
            })
    }

    /**
     * close the Bulk Upload modal
     */
    bulkUploadModalClose(action: string) {
        this.activeModal.close(action);
    }

    protected readonly DocumentBulkUploadStepEnum = DocumentBulkUploadStepEnum;
    uploadModalSubmitted: boolean = false;

    onCSVUploaded(id: number) {
        this.documentsBulkUploadFacade.updateUploadId(id);
        this.documentsBulkUploadFacade.fetchFirstRow();
        this.documentsBulkUploadFacade.fetchPotentialMappings();
    }

    onUploadSettingsChanged(settings: IUploadSettingsResponse) {
        this.documentsBulkUploadFacade.setImportSettings(settings?.settings?.todo);
        this.documentsBulkUploadFacade.firstLineTitlesChange(settings?.settings.first_line_titles === true ? 1 as const : 0 as const);
        this.documentsBulkUploadFacade.onMergeOrganisationsChange(settings?.settings.merge_organizations);
    }

    importPDFClicked() {
         this.documentsBulkUploadFacade.onImportPDFClick();
    }

    onActivityFormDataChanged(settings: IGenerateActivityFormData) {
        this.documentsBulkUploadFacade.setImportSettings(settings);
    }

    onActivityFormDataValidityChanged($event: boolean) {
        this.isActivityFormDataValid = $event;
    }

    onUploadNextButtonClick() {
        this.documentsBulkUploadFacade.uploadId$
            .pipe(switchMap((id) => super.uploadPdfFile({importId: id})
                    .pipe(
                        filter(x => x.every(y => y.progress === 100)),
                        take(1),
                        delay(1000) //Make a delay to show the progress bar for all files
                    )
                ),
                 take(1))
            .subscribe({
                next: () => {
                    this.documentsBulkUploadFacade.saveImportSettings();
                    this.documentsBulkUploadFacade.nextStep();
                }
            });
    }
}